import React from 'react';

function Portfolio() {
  return (
    <div className="portfolio-shell min-h-screen py-20 px-4">
      <div className="max-w-5xl mx-auto text-center portfolio-surface portfolio-surface-strong rounded-3xl p-10 sm:p-14">
        <p className="text-sm uppercase tracking-[0.28em] text-jade-700 dark:text-jade-300 mb-4">
          Jade de Lara
        </p>
        <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 dark:text-gray-100 mb-4">
          Portfolio Coming Soon
        </h1>
        <p className="text-lg text-gray-600 dark:text-gray-400 mb-8 max-w-2xl mx-auto">
          This page is under construction. Check back soon for my complete portfolio.
        </p>
        <a 
          href="/"
          className="inline-flex items-center px-6 py-3 bg-jade-600 text-white rounded-lg font-medium hover:bg-jade-700 transition-all duration-300 shadow-md hover:shadow-xl"
        >
          Return Home
        </a>
      </div>
    </div>
  );
}

export default Portfolio;
